var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"FaqView"},[_c('ShPageLayout',[_c('FaqSearch'),_c('FaqCategories',{attrs:{"faq-categories":_vm.faqCategories}}),_c('FaqList',{attrs:{"faq-list-by-categories":_vm.faqListByCategories}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }